import styled from "styled-components"
import { useState } from "react"
import { FC} from "react";


interface Props {
    closeFunc: () => void;
    title: string;
    submitFunc: (value: string) => void;
}

const EditTextContainer: FC<Props> = ({ closeFunc, title, submitFunc }) => {

    const [ input, setInput ] = useState('')

    const handleChange = (e: any) => {
        setInput(e.target.value)
    }
    const handleSubmit = () => {
        submitFunc(input)
        closeFunc()
    }

    return (
        <Wrapper>
        <Container>
            <HeaderContainer>
                <Header>{title}</Header>
            </HeaderContainer>
            <BodyContainer>
                <Body>
                    <Input onChange={handleChange}></Input>
                </Body>
            </BodyContainer>
            <FooterContainer>
                <Footer>
                    <Button className="btn btn-success btn-sm" onClick={handleSubmit}>SAVE</Button>
                    <Button className="btn btn-secondary btn-sm" onClick={closeFunc}>Close</Button>
                </Footer>
            </FooterContainer>
        </Container>
        </Wrapper>
    )
}

export default EditTextContainer

const Wrapper = styled.div`
width: 100%;
display: flex;
justify-content: center;
`
const Container = styled.div`
background-color: rgba(38,38,38,1);
text-align: center;
padding: 0 0.5rem;
min-width: 250px;
border-radius: 4px;
position: absolute;
`
const HeaderContainer = styled.div`
`
const Header = styled.h6`
padding: 0.5rem 1rem;
margin: 0;
`
const BodyContainer = styled.div`
`
const Body = styled.div`
background-color: rgba(117,117,117,1);
padding: 0.5rem 0;
border-radius: 2px;
`
const Input = styled.input`
border-radius: 2px;
border: none;
background-color: rgba(117,117,117,1);
text-align: center;
&:focus {
    outline: none;
    border: none;
}
`
const FooterContainer = styled.div`
`
const Footer = styled.div`
padding: 0.4rem 0;
display: flex;
justify-content: center;
gap: 0.5rem;
`
const Button = styled.button`
`
